import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// --- Componentes de Carregamento e Layout ---
import MainLayout from './components/MainLayout';
import PrivateRoute from './components/PrivateRoute';

// --- Carregamento Lento (Lazy Loading) das Páginas ---
// Em vez de importar as páginas diretamente, usamos React.lazy.
// Isto diz ao React para carregar o código de cada página apenas quando for necessário.
const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const ToolList = lazy(() => import('./pages/ToolList'));
const ToolDetails = lazy(() => import('./pages/ToolDetails'));
const Reports = lazy(() => import('./pages/Reports'));
const QrScanner = lazy(() => import('./pages/QrScanner'));
const UserList = lazy(() => import('./pages/UserList'));
const Profile = lazy(() => import('./pages/Profile'));
const CategoryList = lazy(() => import('./pages/CategoryList'));
const MaintenanceAlerts = lazy(() => import('./pages/MaintenanceAlerts'));
const KitList = lazy(() => import('./pages/KitList'));
const DataManagement = lazy(() => import('./pages/DataManagement')); 
const TermList = lazy(() => import('./pages/TermList')); 
const CostCenterList = lazy(() => import('./pages/CostCenterList'));

/**
 * @component LoadingFallback
 * @description Um componente simples que é exibido enquanto o código de uma página
 * está a ser descarregado.
 */
const LoadingFallback = () => (
  <div className="flex h-screen w-full items-center justify-center">
    <p>A carregar página...</p>
  </div>
);

/**
 * @component App
 * @description O componente raiz da aplicação, agora otimizado com Code Splitting.
 */
function App() {
  return (
    <Router>
      {/*
        O <Suspense> é um componente do React que nos permite mostrar um "fallback"
        (neste caso, a mensagem "A carregar página...") enquanto esperamos que o
        código de uma página seja descarregado.
      */}
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route element={<PrivateRoute />}>
            <Route element={<MainLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/tools" element={<ToolList />} />
              <Route path="/tools/:id" element={<ToolDetails />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/scanner" element={<QrScanner />} />
              <Route path="/users" element={<UserList />} /> 
              <Route path="/profile" element={<Profile />} />
              <Route path="/categories" element={<CategoryList />} />
              <Route path="/maintenance-alerts" element={<MaintenanceAlerts />} />
              <Route path="/kits" element={<KitList />} /> 
              <Route path="/import" element={<DataManagement />} />
              <Route path="/terms" element={<TermList />} /> 
              <Route path="/cost-centers" element={<CostCenterList />} />
            </Route>                                                                                                                                                                                                                                                                                                                                                                                                                                        
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
